export default __webpack_public_path__ + "static/media/gzh.5cf2ffc6.png";